import { getRadarInformation } from "./redemet.js";
import { getRadarARInformation } from "./hidricosAR.js";
import { emitRadarUpdate } from "../utils/radarEventEmitter.js";
import { emitSatelliteUpdate } from "../utils/satelliteEventEmitter.js";
import { DataINMETAPI } from "./inmet.ts";
import { emitInmetUpdate } from "../utils/inmetEventEmitter.js";

export function setupWebSocket() {
  const configuredUrl = import.meta.env.VITE_WS_URL;
  const apiUrl = import.meta.env.VITE_API_URL;
  const proto = window.location.protocol === "https:" ? "wss" : "ws";

  let wsUrl = configuredUrl;

  if (wsUrl && wsUrl.startsWith("/")) {
    wsUrl = `${proto}://${window.location.host}${wsUrl}`;
  }

  if (!wsUrl && apiUrl) {
    // Ex.: http://localhost:3000/api -> ws://localhost:3000/ws
    wsUrl = apiUrl.replace(/^http/i, "ws").replace(/\/api\/?$/, "/ws");
  }

  if (!wsUrl) {
    // Fallback para ambiente onde API/WS compartilham host
    wsUrl = `${proto}://${window.location.host}/ws`;
  }

  let socket = null;
  let retryTimer = null;
  let closedByApp = false;

  const connect = () => {
    socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      console.log("Connected to WS");
    };

    socket.onmessage = (evt) => {
      try {
        const message = JSON.parse(evt.data);
        
        // Se backend notifica atualização de REDEMET, refetch dos dados
        if (message.source === "REDEMET" && message.type === "cache-update") {
          // Avisa aos listeners depois que os dados novos estão no localStorage
          getRadarInformation().then(emitRadarUpdate);
        }

        // Janela dos radares da Argentina andou: mesmo fluxo/evento do REDEMET
        if (message.source === "HIDRICOS_AR" && message.type === "cache-update") {
          getRadarARInformation().then(emitRadarUpdate);
        }

        // Novas medições do INMET: atualiza o localStorage e avisa as páginas
        if (message.source === "INMET" && message.type === "cache-update") {
          DataINMETAPI().then(emitInmetUpdate);
        }

        // Fila de satélite andou: a página de satélite rebusca as imagens
        if (message.source === "CPPMET" && message.type === "cache-update") {
          emitSatelliteUpdate();
        }
      } catch (error) {
        console.error("Erro ao processar mensagem WebSocket:", error);
      }
    };

    socket.onerror = () => {
      // evita ruído no console em quedas temporárias do backend
    };

    socket.onclose = () => {
      if (closedByApp) return;
      retryTimer = window.setTimeout(connect, 1500);
    };
  };

  connect();

  return () => {
    closedByApp = true;
    if (retryTimer) window.clearTimeout(retryTimer);
    if (socket && socket.readyState <= 1) socket.close();
  };
}
